import { NgModule } from "@angular/core";
import { NzTableModule } from "ng-zorro-antd/table";
import { NzDividerModule } from "ng-zorro-antd/divider";
import {
  AsyncPipe,
  DecimalPipe,
  NgStyle,
  PercentPipe
} from "@angular/common";
import { NzIconModule } from "ng-zorro-antd/icon";
import { LuxonModule } from "luxon-angular";
import { NzGridModule } from "ng-zorro-antd/grid";
import { NzRadioModule } from "ng-zorro-antd/radio";
import { FormsModule } from "@angular/forms";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzSpaceModule } from "ng-zorro-antd/space";
import { NzAutocompleteModule } from "ng-zorro-antd/auto-complete";
import { NzButtonModule } from "ng-zorro-antd/button";
import { PipesModule } from "../pipes/pipes.module";
import { PoSplitDialogComponent } from "./po-split-dialog/po-split-dialog.component";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzSliderModule } from "ng-zorro-antd/slider";
import { NzInputNumberModule } from "ng-zorro-antd/input-number";
import { BatchStatusIconComponent } from "./batch-status-icon/batch-status-icon.component";
import { ScanStatusIconComponent } from "./scan-status-icon/scan-status-icon.component";
import { PoAttachDialogComponent } from "./po-attach-dialog/po-attach-dialog.component";
import { NzSelectModule } from "ng-zorro-antd/select";
import { NzDescriptionsModule } from "ng-zorro-antd/descriptions";
import { NzPageHeaderModule } from "ng-zorro-antd/page-header";
import { FailureReasonComponent } from './failure-reason/failure-reason.component';
import { NzAlertModule } from "ng-zorro-antd/alert";
import { NzTabsModule } from "ng-zorro-antd/tabs";
import { NzImageModule } from "ng-zorro-antd/image";
import { NzSpinModule } from "ng-zorro-antd/spin";
import { NzTooltipModule } from "ng-zorro-antd/tooltip";
import { NzTagModule } from "ng-zorro-antd/tag";
import { NzPopconfirmModule } from "ng-zorro-antd/popconfirm";
import { DatePipe } from "@angular/common";
import { ScanDialogComponent } from "./scan-dialog/scan-dialog.component";
import { DlgBadBucketPositionComponent } from "./dlg-bad-bucket-position/dlg-bad-bucket-position.component";
import { ScanGalleryCardComponent } from "./scan-gallery-card/scan-gallery-card.component";
import { LabThresholdGaugesComponent } from "./lab-threshold-gauges/lab-threshold-gauges.component";
import { JsonObjectPreviewComponent } from "./json-object-preview/json-object-preview.component";
import { LabColorPreviewComponent } from "./lab-color-preview/lab-color-preview.component";
import { FormulationColorPreviewComponent } from "./formulation-color-preview/formulation-color-preview.component";
import { LineStatusIndicatorsComponent } from "./line-status-indicators/line-status-indicators.component";
import { OperatorReasonDialogComponent } from "./operator-reason-dialog/operator-reason-dialog.component";
import { ScanTagsListComponent } from "./scan-tags-list/scan-tags-list.component";
import { InspectionOverlayComponent } from "./inspection-overlay/inspection-overlay.component";


@NgModule({
  imports: [
    NzTableModule, //
    NzDividerModule, //
    NzIconModule, //
    LuxonModule, //
    NzGridModule, //
    NzRadioModule, //
    FormsModule, //
    NzInputModule, //
    NzSpaceModule, //
    NzAutocompleteModule, //
    NzButtonModule, //
    PipesModule, //
    NzModalModule, //
    NzSliderModule, //
    NzInputNumberModule, //
    NgStyle, //
    NzSelectModule, //
    AsyncPipe, //
    NzDescriptionsModule, //
    NzPageHeaderModule, //
    PercentPipe, //
    NzAlertModule, //
    DecimalPipe, //
    NzTabsModule, //
    NzImageModule, //
    NzSpinModule, //
    NzTooltipModule, //
    NzTagModule, //
    NzPopconfirmModule, //
    DatePipe, //
    FailureReasonComponent, //
    DlgBadBucketPositionComponent, //
    ScanGalleryCardComponent, //
    ScanStatusIconComponent, //
    LabThresholdGaugesComponent, //
    JsonObjectPreviewComponent, //
    LabColorPreviewComponent, //
    FormulationColorPreviewComponent, //
    LineStatusIndicatorsComponent, //
    OperatorReasonDialogComponent, //
    ScanTagsListComponent, //
    InspectionOverlayComponent //
  ],
  declarations: [
    PoSplitDialogComponent, //
    BatchStatusIconComponent, //
    PoAttachDialogComponent, //
    ScanDialogComponent //
  ],
  exports: [
    PoSplitDialogComponent, //
    BatchStatusIconComponent, //
    ScanStatusIconComponent, //
    PoAttachDialogComponent, //
    FailureReasonComponent, //
    ScanDialogComponent, //
    DlgBadBucketPositionComponent, //
    ScanGalleryCardComponent, //
    LabThresholdGaugesComponent, //
    LabColorPreviewComponent, //
    FormulationColorPreviewComponent, //
    LineStatusIndicatorsComponent //
  ]
})
export class ComponentsModule {
}
